<template>
  <!--征友条件-->
  <div>
    <van-col span="22" offset="1" class="my_search">
      <!-- mc搜索 -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.mc')" @click="mc_show = true" :value="user.is_mc | getmc(this,$t) " is-link/>
        <van-action-sheet v-model="mc_show" :actions="mc_list" @select="onmcSelect" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>
      <!-- 性别-->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.Gender')" @click="show = true" :value="user.sex | getsex(this,$t) " is-link/>
        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>
      <!-- 年龄 -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.ages')" @click="SetAgeDefault()" :value="user | getage(user)" is-link/>
        <van-action-sheet v-model="showage">
          <van-picker
            class="setage"
            :title="$t('user.ages')"
            show-toolbar
            :columns = 'options_age'
            @confirm = 'onConfirmAge'
            @cancel = 'onChangeAges'
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 城市 -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.Location')" @click="showcity = true" :value="user | getcity" is-link/>
        <van-action-sheet v-model="showcity">
          <van-picker
            :title="$t('user.address')"
            show-toolbar
            :columns="options7"
            @confirm="onConfirmcity"
            @cancel="onChangecitys"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 身高 is_user_height -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.height')" @click="SetheightDefault()" :value="user | getheight(user)" is-link />
        <van-action-sheet v-model="showheight">
          <van-picker
            :title="$t('user.height')"
            show-toolbar
            :columns="options_height"
            @confirm="onConfirmheight"
            @cancel="onChangeheights"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 学历  -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.education')" @click="showdiploma = true" :value="user.diploma" is-link/>
        <van-action-sheet v-model="showdiploma" :actions="options1" @select="ondiploma" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>
      <!-- 月收入 -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.monthly_income')" @click="showincome = true" :value="user.monthly_income" is-link/>
        <van-action-sheet v-model="showincome" :actions="income_array" @select="onincome" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>
      <!--婚姻状况 -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.marital_status')" @click="showmarriage = true" :value="user.marriage" is-link/>
        <van-action-sheet v-model="showmarriage" :actions="options2" @select="onmarriage" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>
      <!-- 职业-->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.occupation')" @click="showprofessional = true" :value="user.professional" is-link/>
        <van-action-sheet v-model="showprofessional">
          <van-picker
            :title="$t('user.occupation')"
            show-toolbar
            :columns="options6"
            @confirm="onConfirmprofessional"
            @cancel="onChangeprofessionals"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>

      <van-col span="24" v-if="is_vip">
        <!-- 体型 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.shape')" @click="showshape = true" :value="user.shape" is-link/>
          <van-action-sheet v-model="showshape" :actions="options_shape" @select="onshape" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 血型 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.blood_type')" @click="showblood = true" :value="user.blood_type" is-link/>
          <van-action-sheet v-model="showblood" :actions="blood_type" @select="onblood" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 出生地 -->
        <van-col span="24" class="my_information_type">
          <van-cell  :title="$t('user.birthplace')" @click="showbirthplace = true" :value="user.birthplace" is-link/>
          <van-action-sheet v-model="showbirthplace">
            <van-picker
              :title="$t('user.birthplace')"
              show-toolbar
              :columns="options7"
              @confirm="onConfirmbirthplace"
              @cancel="onChangebirthplace"
              :confirm-button-text="$t('btn.submit')"
              :cancel-button-text="$t('btn.cancel')"
            />
          </van-action-sheet>
        </van-col>
        <!-- 吸烟情况 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.Smoking')" @click="showSmoking = true" :value="user.Smoking" is-link/>
          <van-action-sheet v-model="showSmoking" :actions="Smoking" @select="onSmoking" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 饮酒情况 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.drinking_situation')" @click="showdrinking = true" :value="user.drinking_situation" is-link/>
          <van-action-sheet v-model="showdrinking" :actions="drinking_situation" @select="ondrinking" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 兄弟姐妹 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.brothers_sisters')" @click="showbrothers = true" :value="user.brothers_sisters" is-link/>
          <van-action-sheet v-model="showbrothers" :actions="brothers_sisters" @select="onbrothers" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 国籍-->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.nationality')" @click="shownationality = true" :value="user.nationality" is-link/>
          <van-action-sheet v-model="shownationality">
            <van-picker
              :title="$t('user.nationality')"
              show-toolbar
              :columns = 'nationality'
              @confirm = 'onConfirmshownationality'
              @cancel = 'onChangeshownationalitys'
              :confirm-button-text="$t('btn.submit')"
              :cancel-button-text="$t('btn.cancel')"
            />
          </van-action-sheet>
        </van-col>
        <!-- 语言  ---  性格  -->
        <van-col span="24" class="my_information_type">
          <van-collapse v-model="showlanguage" accordion>
            <!-- 语言 -->
            <van-collapse-item :title="$t('user.language')" name="1" class="language_type">
              <van-tag v-for="(l,i) in language" :key="l.id"  :class="l.status == 1 ? 'language_type_checked' : 'language_type_center'" @click="language_btn(i)">{{ l.title }}</van-tag>
            </van-collapse-item>
            <!-- 性格 -->
            <van-collapse-item :title="$t('user.character')" name="2" class="language_type">
              <van-tag v-for="(l,i) in character" :key="l.id" :class="l.status == 1 ? 'language_type_checked' : 'language_type_center'" @click="character_btn(i)">{{ l.title }}</van-tag>
            </van-collapse-item>
          </van-collapse>
        </van-col>
        <!-- 对结婚的要求 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.requirements_marriage')" @click="showrequirements = true" :value="user.requirements_marriage" is-link/>
          <van-action-sheet v-model="showrequirements" :actions="requirements_marriage" @select="onrequirements" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>

        <!-- 要不要小孩 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.want_children')" @click="showchildren = true" :value="user.want_children" is-link/>
          <van-action-sheet v-model="showchildren" :actions="want_children" @select="onchildren" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!--  交友状态  -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.friendship_status')" @click="showfriendship = true" :value="user.friendship_status" is-link/>
          <van-action-sheet v-model="showfriendship" :actions="friendship_status" @select="onfriendship" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 约会费用 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.appointment_fee')" @click="showappointment = true" :value="user.appointment_fee" is-link/>
          <van-action-sheet v-model="showappointment" :actions="appointment_fee" @select="onappointment" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 居住情况 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.living_conditions')" @click="showliving = true" :value="user.living_conditions" is-link/>
          <van-action-sheet v-model="showliving" :actions="living_conditions" @select="onliving" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 休息日 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.rest_day')" @click="showday = true" :value="user.rest_day" is-link/>
          <van-action-sheet v-model="showday" :actions="rest_day" @select="onrestday" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>
        <!-- 社交性 -->
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('user.sociality')" @click="showsociality = true" :value="user.sociality" is-link/>
          <van-action-sheet v-model="showsociality" :actions="sociality" @select="onsociality" :cancel-text="$t('btn.cancel')" close-on-click-action/>
        </van-col>

      </van-col>
      <van-col span="18" offset="3" class="search_vip_color" v-else>
        <van-button type="primary" size="large" class="my_information_btn" @click="recharge_vip" >{{ $t('btn.Upgrade_VIP_membership')}}</van-button>
      </van-col>
    </van-col>
    <van-col class="search_btn">
      <van-button type="primary" size="large" class="search_submits" @click="submits" safe-area-inset-bottom>{{ $t('btn.search')}}</van-button>
    </van-col>
  </div>
</template>
<script src="https://unpkg.com/element-ui/lib/index.js"></script>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import { Toast } from 'vant';

  export default {
    filters: {
      getage (user) {
        let age= ''
        if (user.age1 === user.age2) {
          age = user.age1
        }else if (user.age1 && user.age2) {
          age = user.age1 + '-' + user.age2
        }else{
          age = user.age1 ? user.age1 : user.age2
        }
        return age ? age : ''
      },
      getheight(user) {
        let height= ''
        if (user.height1 === user.height2) {
          height = user.height1
        }else if (user.height1 && user.height2) {
          height = user.height1 + '-' + user.height2
        }else{
          height = user.height1 ? user.height1 : user.height2
        }
        return height ? height : ''
      },
      getmc(mc,t) {
        if (mc === 1) {
          return t.$t('user.MC1')
        } else {
          return t.$t('user.MC2')
        }
      },
      getsex (sex,t) {
        if (sex === 1) {
          return t.$t('user.sex1')
        } else if(sex === 2) {
          return t.$t('user.sex2')
        } else {
          return t.$t('Tips.unlimited')
        }
      },
      getcity (u) {
        return u.province +' '+ u.city
      }
    },
    data() {
      return {
        mc_show: false,
        is_vip: true,
        showprofessional: false,
        showmarriage: false,
        showincome: false,
        showdiploma: false,
        showheight: false,
        showcity: false,
        showage: false,
        show: false,
        showshape: false,
        showblood: false,
        showSmoking: false,
        showdrinking: false,
        showbrothers: false,
        shownationality: false,
        showrequirements: false,
        showchildren: false,
        showfriendship: false,
        showappointment: false,
        showcharacter: false,
        showliving: false,
        showday: false,
        showsociality: false,
        showbirthplace: false,
        user: {
          'sex':'1',
          "height1":'',       // 身高
          "height2":'',
          "age1":'',          // 年龄
          "age2":'',          // 年龄
          "diploma":"",      // 学历
          "marriage":"",      // 婚姻状况
          "monthly_income":"", // 月收入
          "professional":"",  // 职业
          "province" :'',   // 省
          "city" :'',        // 市
          "blood_type":"",  // 血型
          "shape" : '', // 体型
          "birthplace":"",       // 出生地
          "Smoking":'',       // 吸烟情况
          "drinking_situation":'',          // 饮酒情况
          "brothers_sisters":"",      // 兄弟姐妹
          "nationality":"",      // 国籍
          "language":"",     // 语言 多个用逗号隔开
          "requirements_marriage":"",   // 对结婚要求
          "want_children" :'',   // 要不要小孩
          "friendship_status" :'',        // 交友状态
          "appointment_fee":'',  // 约会费用
          "character" : '', // 性格，多个用逗号隔开
          "living_conditions" : '', // 居住情况
          "rest_day" : '', // 休息日
          "sociality" : '', // 社交性
          "is_mc": '1'
        },
        actions: [{ name: this.$t('Tips.unlimited'), value: 0 },{ name: this.$t('user.sex1'), value: 1 }, { name: this.$t('user.sex2'), value: 2 }],
        mc_list: [{ name: this.$t('user.MC1'), value: 1 }, { name: this.$t('user.MC2'), value: 2 }],
        options1: [],
        options2: [],
        options_age:[],
        options_height:[],
        income_array: [],
        options6: [],
        options7: [],             // {value: 'zhinan',label: '指南', children: [{value: 'shejiyuanze',label: '设计原则'}]},
        config: {},
        blood_type:[],
        showlanguage: '',
        birthplace:[],
        Smoking: [],
        drinking_situation: [],
        brothers_sisters: [],
        nationality: [],
        language: [],             // {value: 'zhinan',label: '指南', children: [{value: 'shejiyuanze',label: '设计原则'}]},
        requirements_marriage: [],
        want_children: [],
        friendship_status: [],
        appointment_fee: [],
        living_conditions: [],
        rest_day: [],
        sociality: [],
        character:[],
        options_shape: [],
      };
    },
    created: function() {
      this.professional_income()
      this.more_information()
      this.region_list()
      document.title = this.$t('title.screen')
    },
    methods: {
      // 设置默认值
      SetAgeDefault(){
        console.log('dddddddd')
        for (let i=0; i < this.options_age[0].values.length; i ++) {
          if (this.options_age[0].values[i] === this.user.age1 ) {
            this.options_age[0]["defaultIndex"] = i
          }
        }
        for (let i=0; i < this.options_age[1].values.length; i ++) {
          if (this.options_age[1].values[i] === this.user.age2 ) {
            this.options_age[1]["defaultIndex"] = i
          }
        }
        this.showage = true
      },
      SetheightDefault (){
        console.log('dddddddd')
        for (let i=0; i < this.options_height[0].values.length; i ++) {
          if (this.options_height[0].values[i] === this.user.height1 ) {
            this.options_height[0]["defaultIndex"] = i
          }
        }
        for (let i=0; i < this.options_height[1].values.length; i ++) {
          if (this.options_height[1].values[i] === this.user.height2 ) {
            this.options_height[1]["defaultIndex"] = i
          }
        }
        this.showheight = true
      },
      //mc
      onmcSelect (item) {
        // 默认情况下点击选项时不会自动收起 可以通过 close-on-click-action 属性开启自动收起
        this.user.is_mc = item.value === 0 ? 0 : item.value
        this.mc_show = false
      },
      // 血型
      onblood (item) {
        this.user.blood_type = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showblood = false
      },
      // 地址确认
      onConfirmcity (val) {
        // 地址确认
        if(val[0] == this.$t('Tips.unlimited')){
          this.user.province = ''
          this.user.city = ''
        } else {
          this.user.province = val[0]
          this.user.city = val[1]
        }
        this.showcity = false
      },
      onChangecitys () {
        this.showcity = false
      },
      // 地址确认
      onConfirmbirthplace (val) {
        if(val[0] == this.$t('Tips.unlimited')) {
          this.user.birthplace = ''
        } else {
          this.user.birthplace = val[0] + val[1]
        }
        this.showbirthplace = false
      },
      onChangebirthplace () {
        this.showbirthplace = false
      },
      // 吸烟情况
      onSmoking (item) {
        this.user.Smoking = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showSmoking = false
      },
      //饮酒情况
      ondrinking (item){
        this.user.drinking_situation = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showdrinking = false
      },
      // 兄弟姐妹
      onbrothers (item) {
        this.user.brothers_sisters = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showbrothers = false
      },
      // 国籍确认
      onConfirmshownationality (val) {
        this.user.nationality =  val == this.$t('Tips.unlimited') ? '' : val
        this.shownationality = false
      },
      onChangeshownationalitys () {
        this.shownationality = false
      },
      // 对结婚的要求
      onrequirements(item){
        this.user.requirements_marriage = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showrequirements = false
      },
      // 要不要小孩
      onchildren(item) {
        this.user.want_children = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showchildren = false
      },
      //交友状态
      onfriendship(item) {
        this.user.friendship_status = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showfriendship = false
      },
      // 约会费用
      onappointment(item) {
        this.user.appointment_fee = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showappointment = false
      },
      // 居住情况
      onliving(item) {
        this.user.living_conditions = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showliving = false
      },
      // 休息日
      onrestday(item) {
        this.user.rest_day = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showday = false
      },
      // 社交性
      onsociality(item) {
        this.user.sociality = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showsociality = false
      },
      // 语言
      language_btn(i) {
        this.language[i].status = this.language[i].status == 1 ? 0 : 1
        console.log(this.language)
      },
      // 性格
      character_btn(i) {
        this.character[i].status = this.character[i].status == 1 ? 0 : 1
        console.log(this.character)
      },
      onSelect (item) {
        // 默认情况下点击选项时不会自动收起 可以通过 close-on-click-action 属性开启自动收起
        this.user.sex = item.value === 0 ? 0 : item.value
        this.show = false
      },
      onConfirmAge (val) {
        // 年龄确认
        this.user.age1 = val[0] == this.$t('Tips.unlimited') ? '' : val[0]
        this.user.age2 = val[1] == this.$t('Tips.unlimited') ? '' : val[1]
        this.showage = false
      },
      onChangeAges () {
        this.showage = false
      },
      onshape (item) {
        // 体型
        this.user.shape = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showshape = false
      },
      onConfirmheight (val) {
        // 身高确认
        this.user.height1 = val[0] == this.$t('Tips.unlimited') ? '' : val[0]
        this.user.height2 = val[1]== this.$t('Tips.unlimited') ? '' : val[1]
        this.showheight = false
      },
      onChangeheights () {
        this.showheight = false
      },
      ondiploma (item) {
        // 学历
        this.user.diploma = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showdiploma = false
      },
      onincome (item) {
        // 月收入
        this.user.monthly_income = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showincome = false
      },
      onmarriage (item) {
        // 婚姻状况
        this.user.marriage = item.name == this.$t('Tips.unlimited') ? '' : item.name
        this.showmarriage = false
      },
      onConfirmprofessional (val) {
        // 职业确认
        this.user.professional = val[1]
        this.showprofessional = false
      },
      onChangeprofessionals () {
        this.showprofessional = false
      },
      convert: function() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_get_user_search", {
          params: {
            uid: uid,
            token: token
          }
        }).then(res => {
          console.log(res)
          if(res.data.code == 1){
            this.is_vip = res.data.data.is_vip > 0 ? true : false
            const users = res.data.data.search_list
            this.user = users
            this.user.province = users && users.province ? users.province : ''
            this.user.city = users && users.province ? users.city : ''
            // language  语言
            for(let i=0;i < this.language.length; i++ ){
              const tag= this.language[i].title
              if (this.user.language && this.user.language.indexOf(tag) != -1) {
                this.language[i].status = 1
              }else{
                this.language[i].status = 0
              }
            }
            // character 性格
            for(let i=0;i < this.character.length; i++ ){
              const character_tag= this.character[i].title
              if (this.user.character && this.user.character.indexOf(character_tag) != -1) {
                this.character[i].status = 1
              }else{
                this.character[i].status = 0
              }
            }
          }
        })
      },
      // 城市
      region_list() {
        this.options7 = []
        //    const appData = require('../../city.json') // 加载本地数据文件
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        this.options7.push({'text':this.$t('Tips.unlimited'),'label':this.$t('Tips.unlimited'),'children': []})
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_region_list", { params: { uid: uid,token: token}}).then(res => {
          console.log(res.data.data)
          let appData = res.data.data
          for(let i= 0;i< appData.length; i++){
            const professional_list = appData[i].cities
            const  children =[]
            for(let s=0; s < professional_list.length; s++){
              children[s] ={ text: professional_list[s]['areaName'],label: professional_list[s]['areaName']}
            }
            this.options7.push({'text': appData[i]['areaName'],'label': appData[i]['areaName'],'children': children})
          }
          console.log(this.options7)
        })
      },
      // 获取更多选项
      more_information() {
        let i;
        let age1 = []
        let age2 = []
        let height1 = []
        let height2 = []
        age1.push(this.$t('Tips.unlimited'))
        age2.push(this.$t('Tips.unlimited'))
        for(i = 18; i <=70; i++) {
          age1.push(i)
          age2.push(i)
        }
        this.options_age = [
          {'values': age1, 'defaultIndex': 0 },
          {'values': age2, 'defaultIndex': 0 }
        ]
        height1.push(this.$t('Tips.unlimited'))
        height2.push(this.$t('Tips.unlimited'))
        for(i = 133; i <=199; i++) {
          height1.push(i)
          height2.push(i)
        }
        this.options_height = [
          {'values': height1, 'defaultIndex': 0 },
          {'values': height2, 'defaultIndex': 0 }
        ]
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_more_information_val", {
          params: {
            uid: uid,
            token: token
          }
        }).then(res => {
          console.log(res)
          // 血型
          this.blood_type = []
          const blood_type = res.data.data.blood_type
          this.blood_type.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< blood_type.length; i++){
            const blood_mame = {'name': blood_type[i]['title'] }
            this.blood_type.push(blood_mame)
          }
          // 吸烟情况
          this.Smoking = []
          const Smoking= res.data.data.Smoking
          this.Smoking.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< Smoking.length; i++){
            const Smoking_name = {'name': Smoking[i]['title'] }
            this.Smoking.push(Smoking_name)
          }
          // 饮酒情况
          this.drinking_situation = []
          const drinking_situation= res.data.data.drinking_situation
          this.drinking_situation.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< drinking_situation.length; i++){
            const drinking_name = {'name': drinking_situation[i]['title'] }
            this.drinking_situation.push(drinking_name)
          }
          // 兄弟姐妹
          this.brothers_sisters = []
          const brothers_sisters= res.data.data.brothers_sisters
          this.brothers_sisters.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< brothers_sisters.length; i++){
            const brothers_name = {'name': brothers_sisters[i]['title'] }
            this.brothers_sisters.push(brothers_name)
          }
          // 對結婚的要求
          this.requirements_marriage = []
          const requirements_marriage= res.data.data.requirements_marriage
          this.requirements_marriage.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< requirements_marriage.length; i++){
            const requirements_name = {'name': requirements_marriage[i]['title'] }
            this.requirements_marriage.push(requirements_name)
          }
          // 要不要小孩
          this.want_children = []
          const want_children= res.data.data.want_children
          this.want_children.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< want_children.length; i++){
            const want_name = {'name': want_children[i]['title'] }
            this.want_children.push(want_name)
          }
          // 交友状态
          this.friendship_status = []
          const friendship_status= res.data.data.friendship_status
          this.friendship_status.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< friendship_status.length; i++){
            const friendship_name = {'name': friendship_status[i]['title'] }
            this.friendship_status.push(friendship_name)
          }
          // 约会费用
          this.appointment_fee = []
          const appointment_fee= res.data.data.appointment_fee
          this.appointment_fee.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< appointment_fee.length; i++){
            const appointment_name = {'name': appointment_fee[i]['title'] }
            this.appointment_fee.push(appointment_name)
          }
          // 国籍
          this.nationality = []
          const nationality= res.data.data.nationality
          this.nationality.push(this.$t('Tips.unlimited'))
          for(let i= 0;i< nationality.length; i++){
            this.nationality.push( nationality[i]['name'])
          }
          // 语言
          this.language = []
          const language= res.data.data.language
          for(let i= 0;i< language.length; i++){
            const language_name = {'title':language[i]['title'],'status':0}
            this.language.push(language_name)
          }
          // 性格
          this.character = []
          const character= res.data.data.character
          for(let i= 0;i< character.length; i++){
            const character_name = {'title':character[i]['title'],'status':0}
            this.character.push(character_name)
          }
          // 居住情况
          this.living_conditions = []
          const living_conditions= res.data.data.living_conditions
          this.living_conditions.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< living_conditions.length; i++){
            const living_name = {'name': living_conditions[i]['title'] }
            this.living_conditions.push(living_name)
          }
          // 休息日
          this.rest_day = []
          const rest_day= res.data.data.rest_day
          this.rest_day.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< rest_day.length; i++){
            const day_name = {'name': rest_day[i]['title'] }
            this.rest_day.push(day_name)
          }
          // 社交性
          this.sociality = []
          const sociality= res.data.data.sociality
          this.sociality.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< sociality.length; i++){
            const sociality_name = {'name': sociality[i]['title'] }
            this.sociality.push(sociality_name)
          }
          this.convert()
        })
      },
      professional_income() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/professional_income", {
          params: {
            uid: uid,
            token: token
          }
        }).then(res => {
          this.income_array = []
          console.log(res.data.data)
          const incomearr= res.data.data.income
          this.income_array.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< incomearr.length; i++){
            const income = {'name': incomearr[i]['name'] }
            this.income_array.push(income)
          }
          // 婚姻
          this.options2 = []
          const marriage= res.data.data.marriage
          this.options2.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< marriage.length; i++){
            const marriage_name = {'name': marriage[i]['name'] }
            this.options2.push(marriage_name)
          }
          // 学历
          this.options1 = []
          const education= res.data.data.education
          this.options1.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< education.length; i++){
            const education_name = {'name': education[i]['name'] }
            this.options1.push(education_name)
          }
          const professional =res.data.data.professional
          this.options6 =[]
          if(professional){
            this.options6.push({'text': this.$t('Tips.unlimited'),'label': this.$t('Tips.unlimited'),'children': []})
            for(let i= 0;i< professional.length; i++){
              const professional_list = professional[i].professional_list
              const  children =[]
              for(let s=0; s < professional_list.length; s++){
                children[s] ={ text: professional_list[s]['name'],label: professional_list[s]['name']}
              }
              this.options6.push({'text': professional[i]['name'],'label': professional[i]['name'],'children': children})
            }
          }
          // 体型
          this.options_shape = []
          const shape= res.data.data.shape
          this.options_shape.push({'name': this.$t('Tips.unlimited') })
          for(let i= 0;i< shape.length; i++){
            const shape_name = {'name': shape[i]['title'] }
            this.options_shape.push(shape_name)
          }
          // 获取必填选项
          this.config['is_user_height'] =res.data.data.is_user_height;
          this.config['is_user_diploma'] =res.data.data.is_user_diploma;
          this.config['is_user_monthly_income'] =res.data.data.is_user_monthly_income;
          this.config['is_user_marriage'] =res.data.data.is_user_marriage;
          this.config['is_user_professional'] =res.data.data.is_user_professional;
          this.config['is_user_children'] =res.data.data.is_user_children;
          this.config['is_user_shape'] =res.data.data.is_user_shape;
          this.config['is_user_signature'] =res.data.data.is_user_signature;
        })
      },
      submits: function(){
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        let language = ''
        let character= ''
        for(let i=0;i < this.language.length; i++ ){
          if(this.language[i].status == 1){
            language = language + this.language[i].title + ','
          }
        }
        for(let i=0;i < this.character.length; i++ ){
          if(this.character[i].status == 1){
            character = character + this.character[i].title + ','
          }
        }
        if(language){
          language =language.substring(0,language.length - 1)
        }
        if(character) {
          character=character.substring(0,character.length - 1)
        }

        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/add_user_search", {
          params: {
            uid: uid,
            token: token,
            sex:this.user.sex,
            height1: this.user.height1,
            height2: this.user.height2,
            age1: this.user.age1,
            age2: this.user.age2,
            diploma: this.user.diploma,
            marriage: this.user.marriage,
            monthly_income: this.user.monthly_income,
            professional: this.user.professional,
            province: this.user.province,
            city:this.user.city,
            blood_type: this.user.blood_type,
            shape: this.user.shape,
            birthplace: this.user.birthplace,
            Smoking: this.user.Smoking,
            drinking_situation: this.user.drinking_situation,
            brothers_sisters: this.user.brothers_sisters,
            nationality: this.user.nationality,
            language: language,
            requirements_marriage: this.user.requirements_marriage,
            want_children: this.user.want_children,
            friendship_status: this.user.friendship_status,
            appointment_fee: this.user.appointment_fee,
            character: character,
            living_conditions: this.user.living_conditions,
            rest_day: this.user.rest_day,
            sociality: this.user.sociality,
            is_mc: this.user.is_mc
          }
        }).then(res => {
          window.location.href="bogo://personals_jump";
        /*  if(res.data.code == 1){
            Toast(this.$t('Tips.Saved_successfully'))
            setTimeout(() =>{
              window.location.href="bogo://personals_jump";
            },3000)
          }else{
            Toast(res.data.msg)
          }*/
        })
      },
      // 跳转会员vip充值
      recharge_vip() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({path:'/vip',query:{uid:uid, token: token }})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/search.vue